import { useMediaQuery, useTheme } from '@mui/material'

export function useIsDesktopSize() {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.up('desktop'))
}
